import React from "react";
import PageLayout from "../Layouts/PageLayout";
import { Container } from "react-bootstrap";
import "../Styles/Admin.css";
import MerchantIcon from "../Assets/Icons/merchantIcon.svg";
import CustomerIcon from "../Assets/Icons/customerIcon.svg";
import PendingIcon from "../Assets/Icons/pendingIcon.svg";
import RefundIcon from "../Assets/Icons/refundIcon.svg";
import AdminCard from "../Components/AdminCard";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import SearchIcon from "../Assets/Icons/searchIcon.svg";
import MerchantTable from "../Components/MerchantTable";
import Pagination from "react-bootstrap/Pagination";

export default function AdminMerchant() {
  return (
    <Container fluid>
      <PageLayout>
        <div>
          <h1 className="customer-heading">Total Customers</h1>
          <div className="merchant-card-con">
            <AdminCard
              title="Total Merchants"
              img={MerchantIcon}
              id="41564"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Total Customers"
              img={CustomerIcon}
              id="153413"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Pending Requests"
              img={PendingIcon}
              id="4654"
              bottombarbg="#FF7A00"
            />
            <AdminCard
              title="Active Installments"
              img={MerchantIcon}
              id="1564"
              bottombarbg="#008BD9"
            />
            <AdminCard
              title="Refund"
              img={RefundIcon}
              id="₦ 155461564"
              bottombarbg="#FF7A00"
            />
          </div>
          <div className="merchant-parent">
          <h1 className="customer-heading">All Merchants</h1>
          <div className="merchant-table-card-con">
            <div className="merchant-table-input">
              <InputGroup style={{ width: "26rem" }} className="mb-3">
                <Form.Control
                  placeholder="Search by name, email"
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    borderRight: "none",
                    height: "2.6rem",
                    fontSize: "0.90rem",
                  }}
                  className="shadow-none"
                />
                <InputGroup.Text
                  style={{ backgroundColor: "transparent" }}
                  id="basic-addon1"
                >
                  <img src={SearchIcon} />
                </InputGroup.Text>
              </InputGroup>
            </div>
            <MerchantTable />
            <div className="pagination-con">
            <Pagination>
              <Pagination.Prev />
              <Pagination.Item>{1}</Pagination.Item>
              <Pagination.Item>{2}</Pagination.Item>
              <Pagination.Next />
            </Pagination>
            </div>
          </div>
          </div>
        </div>
      </PageLayout>
    </Container>
  );
}
